import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { siteConfig, navLinks } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const handleNavClick = (path: string) => {
    if (path.startsWith('/#')) {
      if (location.pathname === '/') {
        const id = path.replace('/#', '');
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      } else {
        navigate('/');
        setTimeout(() => {
          const id = path.replace('/#', '');
          const el = document.getElementById(id);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center group-hover:bg-primary-600 transition-colors">
              <i className="ri-play-circle-fill text-background-50 text-xl"></i>
            </div>
            <span className="text-xl font-bold text-foreground-900 font-heading">
              {siteConfig.name}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              link.path.startsWith('/#') ? (
                <button
                  key={link.path}
                  onClick={() => handleNavClick(link.path)}
                  className="px-4 py-2 text-sm text-foreground-600 hover:text-primary-500 rounded-lg hover:bg-primary-50 transition-all whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </button>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-2 text-sm rounded-lg transition-all whitespace-nowrap ${
                    location.pathname === link.path
                      ? 'text-primary-500 bg-primary-50 font-medium'
                      : 'text-foreground-600 hover:text-primary-500 hover:bg-primary-50'
                  }`}
                >
                  {link.label}
                </Link>
              )
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-5 py-2 text-sm font-medium text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              立即体验
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-foreground-700 text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              link.path.startsWith('/#') ? (
                <button
                  key={link.path}
                  onClick={() => {
                    handleNavClick(link.path);
                    setMobileMenuOpen(false);
                  }}
                  className="px-4 py-3 text-sm text-foreground-600 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-all text-left whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </button>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-3 text-sm rounded-lg transition-all ${
                    location.pathname === link.path
                      ? 'text-primary-500 bg-primary-50 font-medium'
                      : 'text-foreground-600 hover:text-primary-500 hover:bg-primary-50'
                  }`}
                >
                  {link.label}
                </Link>
              )
            ))}
            <Link
              to="/about"
              className="mt-2 px-5 py-3 text-sm font-medium text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-all text-center whitespace-nowrap"
            >
              立即体验
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}